import Logo from "@/components/elements/Logo";
import { Separator } from "@/components/ui/separator";
import Image from "next/image";
import Link from "next/link";
import React from "react";

const DesktopFooter = () => {
  return (
    <>
      <footer className="flex flex-col gap-14 w-full sm:hidden">
        <header className="w-full flex justify-center items-center">
          <div className="flex gap-2 items-center">
            <Logo size="footer" />
            <div className="flex flex-col text-lg font-bold">
              <h4 className="text-2xl text-[#2E3192]">SKILL</h4>
              <h4 className="text-2xl text-[#00904C]">SEWA</h4>
            </div>
          </div>
        </header>
        <section className="flex justify-center">
          <div className="w-[94vw]">
            <iframe
              title="skillsewa map location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d769.4723003285361!2d85.32445964100926!3d27.690422058822808!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb19a443949671%3A0xef37f5be0fdebdfb!2sSKILL%20SEWA!5e0!3m2!1sen!2snp!4v1743693304598!5m2!1sen!2snp"
              width="100%"
              height="250"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </section>
        <section className="grid grid-cols-2">
          <div className="flex flex-col gap-4">
            <h3 className="text-lg font-bold">QUICK LINKS</h3>
            <ul className="flex flex-col gap-2">
              <li>
                <Link href={"/"}>Home</Link>
              </li>
              <li>
                <Link href={"/#about"}>About Us</Link>
              </li>
              <li>
                <Link href={"/blogs"}>Blog</Link>
              </li>
              <li>
                <Link href={"/designs"}>Designs</Link>
              </li>
              <li>
                <Link href={"/gallery"}>Gallery</Link>
              </li>
              <li>
                <Link href={"/faq"}>FAQ</Link>
              </li>
              <li>
                <Link href={"/videos"}>Videos</Link>
              </li>
            </ul>
          </div>
          <div className="flex flex-col gap-4">
            <h3 className="text-lg font-bold">SERVICES</h3>
            <ul className="flex flex-col gap-2">
              <li>
                <Link href={"/booking?title=Construction"}>Construction</Link>
              </li>
              <li>
                <Link href={"/booking?title=Renovation"}>Interior Design</Link>
              </li>
              <li>
                <Link href={"/booking?title=Terrace Waterproofing"}>Terrace Waterproofing</Link>
              </li>
              <li>
                <Link href={"/booking?title=House Renovation"}>House Renovation</Link>
              </li>
              <li>
                <Link href={"/booking?title=Terrace Remodeling"}>Terrace Renovation</Link>
              </li>
            </ul>
          </div>
        </section>
        <section className="grid grid-cols-2">
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-4">
              <h3 className="text-lg font-bold">LOCATION</h3>
              <span>Radha Krishna Marg, Babarmahal</span>
            </div>
            <div className="flex flex-col gap-4">
              <h3 className="text-lg font-bold">PHONE NO</h3>
              <span>01-5970230</span>
            </div>
            <div className="flex flex-col gap-4">
              <h3 className="text-lg font-bold">EMAIL</h3>
              <span>skillsewaofficial@gmail.com</span>
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <h3 className="text-lg font-bold">SOCIAL LINKS</h3>
            <div className="flex gap-4">
              <Link href={'https://www.facebook.com/skillsewa4'}>
                <Image
                  src={'/assets/icons/social/facebook.png'}
                  height={80}
                  width={80}
                  alt='facebook'
                  className="h-6 w-6"
                />
              </Link>
              <Link href={'https://www.instagram.com/skillsewa/'}>
                <Image
                  src={'/assets/icons/social/instagram.png'}
                  height={80}
                  width={80}
                  alt='facebook'
                  className="h-6 w-6"
                />
              </Link>
              <Link href={'https://www.tiktok.com/@skillsewa?lang=en'}>
                <Image
                  src={'/assets/icons/social/tiktok.png'}
                  height={80}
                  width={80}
                  alt='facebook'
                  className="h-6 w-6"
                />
              </Link>
              <Link href={'https://www.youtube.com/channel/UCsU749-T22JNPnNRKjPj-Ow'}>
                <Image
                  src={'/assets/icons/social/youtube.png'}
                  height={80}
                  width={80}
                  alt='facebook'
                  className="h-6 w-6"
                />
              </Link>
            </div>
          </div>
        </section>
        <section className="flex flex-col gap-4">
          <div className="flex items-center gap-2 text-sm">
            <span>@copyright 2025</span>
            <span>All rights reserved | Skill Sewa</span>
          </div>
          <Separator />
          <div className="flex items-center gap-2 w-full justify-center text-sm">
            <span>Powered By: </span>
            <Link href={"https://themisfitofnightraid.com"}>
              <span>TheMisFitOfNightRaid</span>
            </Link>
          </div>
        </section>
      </footer>
      <footer className="hidden px-10 sm:flex flex-col gap-4 w-full">
        <section className="flex flex-col sm:flex-row gap-10 justify-between">
          <div className="flex flex-col gap-8">
            <div>
              <h2 className="text-2xl">SkillSewa</h2>
            </div>
            <div className="flex">
              <div className="h-[20rem] w-[20rem]">
                <iframe
                  title="skillsewa map location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d769.4723003285361!2d85.32445964100926!3d27.690422058822808!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb19a443949671%3A0xef37f5be0fdebdfb!2sSKILL%20SEWA!5e0!3m2!1sen!2snp!4v1743693304598!5m2!1sen!2snp"
                  width="250"
                  height="250"
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
              <div className="hidden sm:flex flex-col gap-2">
                <h2 className="text-2xl">SkillSewa Pvt Ltd</h2>
                <div className="text-sm flex flex-col gap-1 font-medium text-muted-foreground">
                  <span>Addres: Radha Krishna Marg, Babarmahal</span>
                  <span>Office: 01-5970230</span>
                  <span>Email: skillsewaofficial@gmail.com</span>
                </div>
                <Separator />
                <div className="flex flex-col gap-4">
                  <h3 className="text-lg">Social Links</h3>
                  <div className="flex gap-4">
                    <Link href={'https://www.facebook.com/skillsewa4'}>
                      <Image
                        src={'/assets/icons/social/facebook.png'}
                        height={80}
                        width={80}
                        alt='facebook'
                        className="h-6 w-6"
                      />
                    </Link>
                    <Link href={'https://www.instagram.com/skillsewa/'}>
                      <Image
                        src={'/assets/icons/social/instagram.png'}
                        height={80}
                        width={80}
                        alt='facebook'
                        className="h-6 w-6"
                      />
                    </Link>
                    <Link href={'https://www.tiktok.com/@skillsewa?lang=en'}>
                      <Image
                        src={'/assets/icons/social/tiktok.png'}
                        height={80}
                        width={80}
                        alt='facebook'
                        className="h-6 w-6"
                      />
                    </Link>
                    <Link href={'https://www.youtube.com/channel/UCsU749-T22JNPnNRKjPj-Ow'}>
                      <Image
                        src={'/assets/icons/social/youtube.png'}
                        height={80}
                        width={80}
                        alt='facebook'
                        className="h-6 w-6"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col sm:grid grid-cols-2 gap-10">
            <div className="flex flex-col gap-8">
              <h3 className="text-lg">Quick Links</h3>
              <ul className="flex flex-col gap-4">
                <li>
                  <Link href={"/"}>Home</Link>
                </li>
                <li>
                  <Link href={"/#about"}>About Us</Link>
                </li>
                <li>
                  <Link href={"/blogs"}>Blog</Link>
                </li>
                <li>
                  <Link href={"/designs"}>Designs</Link>
                </li>
                <li>
                  <Link href={"/gallery"}>Gallery</Link>
                </li>
                <li>
                  <Link href={"/#faq"}>FAQ</Link>
                </li>
                <li>
                  <Link href={"/videos"}>Videos</Link>
                </li>
              </ul>
            </div>
            <div className="flex flex-col gap-8">
              <h3 className="text-lg">Services</h3>
              <ul className="flex flex-col gap-4">
                <li>
                  <Link href={"/booking?title=Construction"}>Construction</Link>
                </li>
                <li>
                  <Link href={"/booking?title=Renovation"}>Interior Design</Link>
                </li>
                <li>
                  <Link href={"/booking?title=Terrace Waterproofing"}>Terrace Waterproofing</Link>
                </li>
                <li>
                  <Link href={"/booking?title=House Renovation"}>House Renovation</Link>
                </li>
                <li>
                  <Link href={"/booking?title=Terrace Remodeling"}>Terrace Renovation</Link>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <section className="flex flex-col sm:flex-row justify-between text-sm font-medium">
          <div className="flex items-center gap-2">
            <span>@copyright 2025</span>
            <span>All rights reserved | Skill Sewa</span>
          </div>
          <div className="flex items-center gap-2">
            <span>Powered By: </span>
            <Link href={"https://themisfitofnightraid.com"}>
              <span>TheMisFitOfNightRaid</span>
            </Link>
          </div>
        </section>
      </footer>
    </>
  );
};

export default DesktopFooter;
